import { Box, Button, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const JustifyBox = styled(FlexBox)(() => ({
  maxWidth: 320,
  flexDirection: "column",
  justifyContent: "center",
}));

const IMG = styled("img")(() => ({
  width: "100%",
  marginBottom: "32px",
}));

const NotFoundRoot = styled(FlexBox)(() => ({
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh !important",
}));

const NotFound = () => {
  return (
    <NotFoundRoot>
      <JustifyBox>
        {/* <IMG src="/assets/images/illustrations/404.svg" alt="" /> */}
        <h1>Unauthorized access!</h1>
      </JustifyBox>
    </NotFoundRoot>
  );
};

export default NotFound;
